import { IApiResult, IApiFunc } from "auth/interface/api.interface";
import { useApi } from "auth/useApi3";
import { apiEndpoints } from "generated/apiEndpoints";
import { WorkshopData } from "./Workshop.interfaces";
import { useMemo } from "react";

interface CarWorkshop {
  id: number;
  name: string;
  emailAddress: string;
  isActive: boolean;
  companyId: number;
}

interface WorkshopActions {
  submit: (values: WorkshopData) => void
}

interface IWorkshop {
  data: CarWorkshop;
  status: number;
  isSuccess: boolean
  actions: WorkshopActions
}

export const useWorkshop = (): IWorkshop => {
  const [workshopResponse, workshopApi] = useApi() as [IApiResult, IApiFunc];

  function handleWorkshopSubmit(formikValues: WorkshopData) {
    if (formikValues.id) {
      const url = apiEndpoints.vehicleregistrychecks.updatecarworkshop;
      workshopApi.put(url, formikValues);
      return;
    }
    const url = apiEndpoints.vehicleregistrychecks.createcarworkshop;
    workshopApi.post(url, formikValues);
  }

  return {
    data: workshopResponse.data,
    status: workshopResponse.status,
    isSuccess: workshopResponse.status === 2,
    actions: {
      submit: handleWorkshopSubmit
    }
  }
}
